import "./topNav.scss";
import { ReactComponent as Logo } from "../../../../assets/logo.svg";
import { ReactComponent as LogOutIcon } from "../../../../assets/logoutIcon.svg";
import { useNavigate } from "react-router-dom";
import { UserDataModel } from "../../../models/userDataModel";
import { useEffect } from "react";

export default function MainTopNav(props: {
  index?: number;
  username?: string;
}) {
  const userData: UserDataModel = JSON.parse(
    localStorage.getItem("techsauce-campaign-user-data") ?? "{}"
  );

  const navigate = useNavigate();
  const navigation = () => {
    return (
      <div className="nav-buttons-container">
        <div
          className={`nav-button ${props.index === 0 && "nav-button-active"}`}
          onClick={() => navigate("/home")}
        >
          Home
        </div>
        {userData.userData?.role === "admin" && (
          <div
            className={`nav-button ${props.index === 1 && "nav-button-active"}`}
            onClick={() => navigate("/user-management")}
          >
            User Management
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="main-top-nav">
      <div className="main-top-nav-inner-container">
        <Logo height={70} width={70} />
        <div className="nav-buttons-top">{navigation()}</div>
        <div className="welcome-text">
          {"Welcome, " + userData.userData?.fullName}
          <LogOutIcon
            height={25}
            width={25}
            onClick={() => {
              localStorage.removeItem("techsauce-campaign-user-data");
              navigate("/admin");
            }}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
      <div className="nav-buttons-bottom">{navigation()}</div>
    </div>
  );
}
